export function clearStorage() {
    if (sessionStorage.getItem("user")) {
      sessionStorage.removeItem("user");
    } else {
      localStorage.removeItem("user");
    }
  };